<!-- Reset Password -->
<section>
    <div class="container content-box">

        <!-- Form -->
        <form name="form" class="" (submit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
            <h1 class="text-center">Reset Password</h1>

            <!-- Input Fields -->
            <div class="col-md-12">

                <!-- Input Row-->
                <div class="row mt-2">

                    <!-- Password -->
                    <div class="col-md-12">
                        <label class="required-field">New Password</label>
                        <input type="password" id="password" class="form-control mb-2" placeholder="Password" [(ngModel)]="user.password" name="password" #password="ngModel" [ngClass]="{ 'is-invalid': f.submitted && password.invalid }" password required minlength="6">

                        <!-- Invalid Password -->
                        <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                            <div class="mb-1 text-center" *ngIf="password.errors!.required">Password is required</div>
                            <div class="mb-1 text-center" *ngIf="password.errors!.minlength">Password must be at least 6 characters</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row-->
                <div class="row mt-2">

                    <!-- Confirm Password -->
                    <div class="col-md-12">
                        <label class="required-field">Confirm New Password</label>
                        <input type="password" id="confirmPassword" class="form-control mb-2" placeholder="Repeat Password" [(ngModel)]="user.confirmPassword" name="confirmPassword" #confirmPassword="ngModel" [ngClass]="{ 'is-invalid': f.submitted && confirmPassword.invalid }"
                            password required validateEqual="password" minlength="6">

                        <!-- Invalid Confirm Password -->
                        <div *ngIf="f.submitted && confirmPassword.invalid" class="invalid-feedback">
                            <div class="mb-1 text-center" [hidden]="confirmPassword.valid || (confirmPassword.pristine && !f.submitted)">Password and Confirm Password need to match</div>
                            <div class="mb-1 text-center" *ngIf="confirmPassword.errors!.minlength">Confirm Password must be at least 6 characters</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Submit -->
            <div class="text-center">
                <button type="submit" class="my-4 btn">Submit</button>
            </div>
        </form>
    </div>
</section>